import './index.scss'
import '../../assets/scripts/number.js'
import Swiper from 'swiper/swiper-bundle.min.js'
// 数字滚动
var wrapTop = $(".about .section2").offset().top;
var istrue = true;
var s = $(window).scrollTop();
if (s > wrapTop - $(".about .section1").offset().top  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s > wrapTop - $(".about .section1").offset().top  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})

var swiper = new Swiper(".section3 .mySwiper", {
    loop:true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
	},
	speed:1000,
});

var honor = new Swiper(".section6 .mySwiper", {
    slidesPerView: 6,
    spaceBetween: '1.82%',
    loop:true,
    speed:2000,//匀速时间
    autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 6,
        spaceBetween: '3.82%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 4,
        spaceBetween: '1.82%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        spaceBetween: 10,
      }
    } 
});